"use client";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./cookieconsent.scss";
import * as _CookieConsent from "vanilla-cookieconsent";
import { useEffect } from "react";
import { gtag } from "../GoogleTagManager";
import { Translation } from "vanilla-cookieconsent";

type TranslationLoader = () => Promise<{
  [locale: string]:
    | Translation
    | string
    | (() => Translation)
    | (() => Promise<Translation>);
}>;

export interface CookieConsentProps {
  translationLoader: TranslationLoader;
  defaultLocale?: string;
  cookieBannerShowAfterSecond?: number;
}

const loadCookieConsent = async ({
  translationLoader,
  defaultLocale = "en",
}: {
  translationLoader: TranslationLoader;
  defaultLocale?: string;
}) => {
  const translations = await translationLoader();

  await _CookieConsent.run({
    revision: 1,
    cookie: {
      expiresAfterDays: (acceptType) => (acceptType === "necessary" ? 5 : 90),
      useLocalStorage: true,
    },
    guiOptions: {
      consentModal: {
        layout: "cloud",
        position: "bottom center",
        equalWeightButtons: false,
        flipButtons: false,
      },
      preferencesModal: {
        layout: "box",
        position: "right",
        equalWeightButtons: false,
        flipButtons: false,
      },
    },
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        autoClear: {
          cookies: [
            {
              name: /^(_ga|_gid)/,
            },
          ],
        },
      },
      marketing: {
        autoClear: {
          cookies: [
            {
              name: /^(_gads)/,
            },
          ],
        },
      },
    },

    language: {
      default: defaultLocale,
      autoDetect: "document",
      translations: translations,
    },

    onConsent: ({ cookie }) => {
      console.debug("onConsent", cookie);
      if (cookie.categories.includes("analytics")) {
        gtag("consent", "update", {
          analytics_storage: "granted",
        });
      } else {
        gtag("consent", "update", {
          analytics_storage: "denied",
        });
      }
      if (cookie.categories.includes("marketing")) {
        gtag("consent", "update", {
          ad_storage: "granted",
          ad_user_data: "granted",
          ad_personalization: "granted",
        });
      } else {
        gtag("consent", "update", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
        });
      }
    },
    onFirstConsent: () => {},
    onChange: () => {},
  });
};

export const CookieConsent = ({
  translationLoader,
  defaultLocale,
  cookieBannerShowAfterSecond = 4,
}: CookieConsentProps) => {
  useEffect(() => {
    setTimeout(
      () =>
        loadCookieConsent({
          translationLoader,
          defaultLocale,
        }),
      cookieBannerShowAfterSecond * 1000,
    );
  }, [translationLoader, defaultLocale, cookieBannerShowAfterSecond]);
  return <></>;
};

export const openCookieConsent = () => {
  _CookieConsent.showPreferences();
};

export default CookieConsent;
